import React from 'react';
// import './App.css';

const AboutUsEN = () => {
  return (
    <div className="container">
      <header className="header">
        <h1>Order Multi</h1>
        <p>Providing high-quality service, low prices, and stable performance to millions of users</p>
      </header>
      <section className="section">
        <h2>Solutions</h2>
        <ul>
          <li>Customer Ordering</li>
          <li>Kitchen Preparation</li>
          <li>Service Calling</li>
          <li>Staff Management</li>
          <li>Order Management</li>
          <li>Membership Marketing</li>
          <li>Restaurant Private Traffic Protection</li>
        </ul>
      </section>
      <section className="section">
        <h2>Goals</h2>
        <p>Standardize and simplify business processes to help restaurants operate efficiently.</p>
      </section>
      <section className="section">
        <h2>Service Scope</h2>
        <p>Currently, Feige Ordering serves the local catering industry not only in China but also in Europe, Japan, Vietnam, Singapore, Portugal, France, the United Kingdom, Germany, Spain, Italy, Romania, Russia, Iran, Indonesia, Australia, the Philippines, Canada, the United States, Chile, and other places.</p>
      </section>
      <section className="section">
        <h2>Agency Partners</h2>
        <p>France, Spain, Canada, Vietnam, Laos, Singapore, New Zealand, Philippines, etc.</p>
      </section>
      <section className="section">
        <h2>Developer Information</h2>
        <p>Shanghai Ranmo Technology Co., Ltd.</p>
      </section>

      <footer className="footer">
        <p>&copy; 2024 Order Multi. All rights reserved.</p>
      </footer>
    </div>
  );
};

export default AboutUsEN;
